module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[43]286.95d2dcb.woff2";